//#region IMPORTAÇÕES
import { Component, OnInit, Input, HostListener } from "@angular/core";
import { LocalStorageService } from "../../services/localStorage.service";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppService } from "../../../app.service";
import { ProductService } from "../../services/product.service";
//#endregion

@Component({
  selector: "app-header-one",
  templateUrl: "./header-one.component.html",
  styleUrls: ["./header-one.component.scss"],
})
export class HeaderOneComponent implements OnInit {
  @Input() class: string;
  @Input() themeLogo: string = "assets/images/icon/logo.png";
  @Input() topbar: boolean = true;
  @Input() sticky: boolean = false;
  usuarioLogado: any;

  public stick: boolean = false;

  constructor(
    public localStorageService: LocalStorageService,
    private router: Router,
    private modalService: NgbModal,
    public appService: AppService,
    public productService: ProductService
  ) {}

  ngOnInit(): void {
    this.usuarioLogado = this.localStorageService.get("usuarioLogado");
  }

  resetValidateLocation() {
    localStorage.removeItem("location");
    localStorage.setItem("linkDireto", "false");
    if (this.router.url == `/home/fashion`) {
      window.location.reload();
    } else {
      this.router.navigate([`home/fashion`]);
    }
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (number >= 150 && window.innerWidth > 400) {
      this.stick = true;
    } else {
      this.stick = false;
    }
  }

  fazerLogout() {
    var pegarDadosLocalStorage = this.localStorageService.get("usuarioLogado");
    if (pegarDadosLocalStorage != null) {
      this.localStorageService.remove("usuarioLogado");
      this.router.navigate(["/pages/login"]);
      window.location.href = "/pages/login";
    }
  }

  redirecionarHome() {
    localStorage.setItem("linkDireto", "false");
    this.router.navigate(["/home/fashion"]);
  }
}
